import type { AnimationEvent } from '@angular/animations';
import type { StepContentPositionState } from '@angular/cdk/stepper';
import { CdkStepper } from '@angular/cdk/stepper';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Subject } from 'rxjs';
import { tabAnimation } from './tabs.animation';

@Component({
  standalone: false,
  selector: 'palantir-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CdkStepper,
      useExisting: PalantirTabsComponent,
    },
  ],
  animations: [tabAnimation],
})
export class PalantirTabsComponent extends CdkStepper {
  public readonly animationDone$ = new Subject<AnimationEvent>();

  public selectStepByIndex(index: number): void {
    this.selectedIndex = index;
  }

  public getAnimationDirection(index: number): StepContentPositionState {
    const position = index - this.selectedIndex;
    if (position < 0) {
      return 'previous';
    } else if (position > 0) {
      return 'next';
    }

    return 'current';
  }
}
